import { SvgIcon } from '@mui/material'
import React from 'react'

export const UserCheck = ({ sx, ...props }) => {
    return (
        <SvgIcon {...{ sx: sx?.color ? { ...sx, stroke: sx.color, color: '#fff' } : sx, width: 15, height: 15, ...props }} viewBox='0 0 33 33 '>
            <path d="M19.25 26.5179L21.725 28.875L27.5 23.375M20.625 20.9752C19.066 19.8877 17.17 19.25 15.125 19.25C10.0786 19.25 5.93923 23.1337 5.53275 28.0752C5.51165 28.3318 5.50109 28.4602 5.55198 28.576C5.59444 28.6727 5.67902 28.7645 5.77189 28.8148C5.88322 28.875 6.02214 28.875 6.3 28.875H13.75M20.625 9.625C20.625 12.6626 18.1626 15.125 15.125 15.125C12.0874 15.125 9.625 12.6626 9.625 9.625C9.625 6.58743 12.0874 4.125 15.125 4.125C18.1626 4.125 20.625 6.58743 20.625 9.625Z" stroke="#0DC9C8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </SvgIcon>
    )
}
